import React, { Component } from 'react';

class File extends Component {
    
    getFileName(){
        return (this.props.data.labelFile) ? this.props.data.labelFile : this.props.data.url.split(/(\\|\/)/g).pop()
    }

    render() {
        
        return (
            <div className="nlf-viewer-block nlf-viewer-file">
                <div className="nlf-viewer-file-filename">
                    <a href={this.props.data.url}>{this.getFileName()}</a>
                </div>
                {this.props.data.showButtonDownload && <div className="nlf-viewer-button nlf-viewer-button-download"><a href={this.props.data.url} className="btn btn-default" download={this.getFileName()}><span>{this.props.data.labelButton}</span></a></div>}
            </div>
        )
        
    }
}

export default File


// WEBPACK FOOTER //
// ./src/File.js